(function(){
  var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var d=document;
  function clamp(v){return v<0?0:v>1?1:v}
  function vh(){return window.innerHeight}
  function pin(el){var r=el.getBoundingClientRect(),dist=r.height-vh();if(dist<=0)return r.top<=0?1:0;return clamp(-r.top/dist)}
  function pass(el){var r=el.getBoundingClientRect();return clamp((vh()-r.top)/(vh()+r.height))}

  function init(){
    d.body.classList.add('is-loaded');
    var HOME=d.body.classList.contains('ig-tpl-index')&&!RM;
    /* accueil : les textes reapparaissent a chaque passage vers le bas */
    var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('is-in');if(!HOME)io.unobserve(e.target)}
      else if(HOME&&e.boundingClientRect.top>0)e.target.classList.remove('is-in');
    })},{threshold:.18,rootMargin:'0px 0px -6% 0px'}):null;
    if(HOME){
      d.querySelectorAll('.ig-tpl-index .ig-h2:not(.ig-mask-group):not([data-ig-lux])').forEach(function(el){el.setAttribute('data-ig-lux','')});
      d.querySelectorAll('.shopify-section').forEach(function(sec){
        if(sec.querySelector('.ig-hero'))return;var n=0;
        sec.querySelectorAll('.ig-eyebrow,.ig-body,.ig-link,.ig-btn,.ig-tour__name,.ig-tour__chapters,.ig-tour__card .ig-mono,.ig-fin__label,.ig-serv__item,.ig-card__meta,.ig-edit__links,.ig-coll__head .ig-mono').forEach(function(el){
          if(el.closest('[data-ig-reveal],.ig-rv,[data-ig-lux]')||el.querySelector('[data-ig-reveal]'))return;
          el.classList.add('ig-rv');el.style.setProperty('--rv',n++%6);
        });
      });
    }
    d.querySelectorAll('[data-ig-lux],.ig-tpl-index .ig-coll__head h2,.ig-tpl-index .ig-tour__head h2').forEach(function(el){
      if(el._lux)return;el.setAttribute('data-ig-lux','');el._lux=1;el.removeAttribute('data-ig-reveal');
      var txt=el.textContent.replace(/\s+/g,' ').trim(),i=0;el.textContent='';
      txt.split(' ').forEach(function(w,k){if(k){el.appendChild(d.createTextNode(' '))}var s=d.createElement('span');s.className='ig-w';s.style.setProperty('--i',i++);s.textContent=w;el.appendChild(s)});
      el.setAttribute('aria-label',txt);
    });
    d.querySelectorAll('[data-ig-reveal],.ig-mask-group,[data-ig-lux],.ig-rv').forEach(function(el){io?io.observe(el):el.classList.add('is-in')});
    d.querySelectorAll('.ig-clip').forEach(function(el){var p=el.parentElement;p.classList.add('ig-clip-host');io?io.observe(p):p.classList.add('is-in');
      var imgs=el.querySelectorAll('img');
      if('IntersectionObserver' in window){var pre=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){imgs.forEach(function(i){i.loading='eager'});pre.disconnect()}})},{rootMargin:'0px 0px 150% 0px'});pre.observe(p)}else{imgs.forEach(function(i){i.loading='eager'})}
    });
    d.querySelectorAll('[data-ig-gal]').forEach(function(g){
      var figs=[].slice.call(g.querySelectorAll('.ig-pdp__fig')),out=g.querySelector('[data-ig-gal-i]');
      if(!out||!figs.length||!('IntersectionObserver' in window))return;
      var go=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)out.textContent=('0'+(figs.indexOf(e.target)+1)).slice(-2)})},{threshold:.55});
      figs.forEach(function(f){go.observe(f)});
    });
    var pf=d.getElementById('ig-pdp-form'),bar=d.querySelector('.ig-pdp__bar');
    if(pf&&bar&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){var on=!e.isIntersecting&&e.boundingClientRect.top<0;bar.classList.toggle('is-on',on);bar.setAttribute('aria-hidden',on?'false':'true');bar.querySelector('button').tabIndex=on?0:-1})}).observe(pf);
    }
    if(RM)return;

    var heroes=[].slice.call(d.querySelectorAll('[data-ig="hero"]'));
    var words=[].slice.call(d.querySelectorAll('[data-ig="words"]')).map(function(el){return{el:el,w:[].slice.call(el.querySelectorAll('.ig-statement__text span'))}});
    var tours=[].slice.call(d.querySelectorAll('[data-ig="tour"]')).map(function(el){
      return{el:el,f:[].slice.call(el.querySelectorAll('.ig-tour__frames img')),t:[].slice.call(el.querySelectorAll('.ig-tour__ring line')),c:[].slice.call(el.querySelectorAll('.ig-tour__chapters li')),deg:el.querySelector('.ig-tour__deg'),last:-1,sec:el.closest('.shopify-section'),lead:0}
    });
    var colls=[].slice.call(d.querySelectorAll('[data-ig="coll"]')).map(function(el){return{el:el,tr:el.querySelector('.ig-coll__track')}});
    var pars=[].slice.call(d.querySelectorAll('[data-ig-par]'));

    tours.forEach(function(t){t.f.forEach(function(im){if(im.dataset.src){im.src=im.dataset.src}})});

    function sizeColls(){tours.forEach(function(t){t.lead=t.sec?Math.max(0,-parseFloat(getComputedStyle(t.sec).marginTop||0)-vh()):0});colls.forEach(function(c){
      if(window.innerWidth<990){c.el.style.height='';c.max=0;return}
      c.max=Math.max(0,c.tr.scrollWidth-window.innerWidth);
      c.el.style.height=(c.max+vh())+'px';
    })}
    sizeColls();

    var tourRun=false;
    function drawTour(t,p){
      var n=t.f.length;if(!n)return;
      var x=p*(n-1),i=Math.min(n-1,Math.floor(x)),fr=x-i;
      for(var k=0;k<n;k++){var o=k===i?1:(k===i+1?fr:0);if(t.f[k]._o!==o){t.f[k].style.opacity=o.toFixed(3);t.f[k]._o=o}}
      var on=Math.round(p*t.t.length);
      if(on!==t.last){t.t.forEach(function(l,j){l.classList.toggle('on',j<on)});t.last=on}
      if(t.deg)t.deg.textContent=Math.round(p*360)+'°';
      t.el.style.setProperty('--deg',(p*360).toFixed(2)+'deg');
      t.el.style.setProperty('--tb',Math.sin(p*Math.PI).toFixed(4));
      var ci=Math.min(t.c.length-1,Math.floor(p*t.c.length));
      if(ci!==t.ci){t.c.forEach(function(li,j){li.classList.toggle('is-active',j===ci)});t.ci=ci}
    }
    function tourTick(){
      var again=false;
      tours.forEach(function(t){if(t.q==null)return;var dq=t.p-t.q;if(Math.abs(dq)>.0005){t.q+=dq*.45;again=true}else t.q=t.p;drawTour(t,t.q)});
      if(again)requestAnimationFrame(tourTick);else tourRun=false;
    }
    var ticking=false;
    function update(){
      ticking=false;
      heroes.forEach(function(h){h.style.setProperty('--p',pin(h).toFixed(4))});
      words.forEach(function(o){
        var r=o.el.getBoundingClientRect();var p=clamp((vh()*.85-r.top)/(r.height*.75));
        var n=Math.round(p*o.w.length);
        o.w.forEach(function(s,i){s.classList.toggle('on',i<n)});
      });
      tours.forEach(function(t){
        t.p=t.lead?(function(){var r=t.el.getBoundingClientRect(),ds=r.height-vh()-t.lead;return ds>0?clamp((-r.top-t.lead)/ds):0})():pin(t.el);
        if(t.q==null)t.q=t.p;
      });
      if(tours.length&&!tourRun){tourRun=true;requestAnimationFrame(tourTick)}
      colls.forEach(function(c){if(!c.max)return;c.tr.style.setProperty('--x',(pin(c.el)*c.max).toFixed(1))});
      pars.forEach(function(el){var r=el.getBoundingClientRect();if(r.bottom<-200||r.top>vh()+200)return;el.style.setProperty('--q',pass(el).toFixed(4))});
    }
    function req(){if(!ticking){ticking=true;window.requestAnimationFrame(update)}}
    d.addEventListener('scroll',req,{passive:true,capture:true});
    window.addEventListener('resize',function(){sizeColls();req()});
    window.addEventListener('load',function(){sizeColls();req()});
    update();
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
  d.addEventListener('shopify:section:load',function(){setTimeout(init,50)});
})();
